export default __webpack_public_path__ + "static/media/logo-ssi-new.7562c3c6.png";